export default __webpack_public_path__ + "static/media/userIcon.599e1c8c.svg";